import * as type from "./constants";

export const getRegion = () => {
  return {
    type: type.GET_REGION,
  };
};

export const getStrategies = () => {
  return {
    type: type.GET_STRATEGIES,
  };
};
export const getSpecialities = (payload, onSuccess) => {
  return {
    type: type.GET_SPECIALITIES,
    payload,
    onSuccess,
  };
};

export const createFunds = (payload, onSuccess) => {
  return {
    type: type.CREATE_FUND,
    payload,
    onSuccess,
  };
};
